import { render, staticRenderFns } from "./Comparador.vue?vue&type=template&id=a7c92dca&scoped=true"
import script from "./Comparador.vue?vue&type=script&lang=js"
export * from "./Comparador.vue?vue&type=script&lang=js"
import style0 from "./Comparador.vue?vue&type=style&index=0&id=a7c92dca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7c92dca",
  null
  
)

export default component.exports